module.exports = __webpack_public_path__ + "9def73f10c8709215c48d7eccf0288b0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TZ.svg
// module id = croe
// module chunks = 0